import videojs from 'video.js';

import { Event } from '@src/types/event';

const PlayToggle = videojs.getComponent('PlayToggle');

class CustomPlayToggle extends PlayToggle {
  public handleClick(evt: videojs.EventTarget.Event) {
    this.player().trigger(Event.X_CLICK_PLAYTOGGLE);
    super.handleClick(evt);
  }

  handleEnded(evt: videojs.EventTarget.Event) {
    const isPlaying = this.player_.paused() === false;
    const isBlockAd = this.player_.contextPlugin?.state?.blockAd;

    // player may emit multiple end event after resolving the postroll ad request lately
    // which cause the play toggle having an incorrect UI state
    if (isPlaying && !isBlockAd) {
      return;
    }
    super.handleEnded(evt);
  }
}

// override video.js original PlayToggle
videojs.registerComponent('PlayToggle', CustomPlayToggle);

export default CustomPlayToggle;
